import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  StatusBar,
  TouchableOpacity,
} from 'react-native';
import TabBar from '../components/TabBar';
import DashboardHeader from '../components/DashboardHeader';
import { COLORS } from '../theme/themeTokens';

interface TransferSuccessScreenProps {
  onBackToDashboard: () => void;
  onNavigate: (screen: string) => void;
}

const TransferSuccessScreen: React.FC<TransferSuccessScreenProps> = ({
  onBackToDashboard,
  onNavigate,
}) => {
  return (
    <View style={styles.container}>
      <StatusBar barStyle="light-content" backgroundColor={COLORS.primaryNavy} />
      <DashboardHeader
        onNavigate={onNavigate}
        variant="solid"
      />

      <View style={styles.content}>
        {/* Success Message */}
        <View style={styles.messageContainer}>
          <Text style={styles.title}>Request submitted</Text>
          <Text style={styles.subtitle}>
            Your request has been received{'\n'}and is currently being processed.
          </Text>
        </View>

        {/* Back to Dashboard Button */}
        <TouchableOpacity
          style={styles.button}
          onPress={onBackToDashboard}
          activeOpacity={0.8}
        >
          <Text style={styles.buttonText}>Back to dashboard</Text>
        </TouchableOpacity>

      </View>

      <TabBar activeTab="dashboard" onNavigate={onNavigate} />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: COLORS.primaryNavy,
  },
  content: {
    flex: 1,
    backgroundColor: COLORS.pureLight,
    borderTopLeftRadius: 12,
    borderTopRightRadius: 12,
    marginTop: 10,
    paddingTop: 40,
    paddingHorizontal: 20,
  },
  messageContainer: {
    alignItems: 'center',
    marginBottom: 40,
  },
  title: {
    fontFamily: 'Inter',
    fontWeight: '600',
    fontSize: 26,
    lineHeight: 29,
    color: COLORS.steelNavy,
    marginBottom: 12,
    textAlign: 'center',
  },
  subtitle: {
    fontFamily: 'Inter',
    fontWeight: '400',
    fontSize: 18,
    lineHeight: 22,
    color: COLORS.blueSteel,
    textAlign: 'center',
  },
  button: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 10,
    gap: 12,
    height: 48,
    backgroundColor: COLORS.brandOrange,
    borderRadius: 4,
    alignSelf: 'stretch',
    marginBottom: 24,
  },
  buttonText: {
    fontFamily: 'Inter',
    fontWeight: '500',
    fontSize: 16,
    lineHeight: 22,
    color: COLORS.white,
  },
  infoText: {
    fontFamily: 'Inter',
    fontWeight: '400',
    fontSize: 16,
    lineHeight: 22,
    color: COLORS.blueSteel,
    textAlign: 'center',
  },
});

export default TransferSuccessScreen;
